import { render, staticRenderFns } from "./AnnouncementsStack.vue?vue&type=template&id=4ef36a3e&"
import script from "./AnnouncementsStack.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementsStack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports